import { popupFilterMappings } from "./PopupFilter";


export const appendPopupFilters = (url, loc, filters = {}) => {
    console.log(loc,filters,"gjhdgf")
  const mapping = popupFilterMappings[loc];

  // Popup has no filter configuration
  if (!mapping) {
    return url;
  }

  Object.entries(filters).forEach(([field, values]) => {
    const apiParam = mapping[field];

    if (
      apiParam &&
      Array.isArray(values) &&
      values.length
    ) {
      url += `&${apiParam}=${encodeURIComponent(values.join(","))}`;
    }
  });

  return url;
};